import firebase from 'firebase';
import { useStrict } from 'mobx';
import config from './config/firebase';

useStrict(true);
firebase.initializeApp(config);


// WEBPACK FOOTER //
// ./src/initialize.js